export default "__VITE_ASSET__21b67c34__"